import React from 'react';
import useFetch from '../hooks/useFetch';
import { PESQUISAR_CONTRATOS_PJ } from '../../services/delegacao';
import { PESQUISAR_CONTRATOS_SUPERVISOR } from '../../services/delegacaoAcesso';
import Datalist from './Datalist';

const SelectContratos = ({
  idCorreios,
  dadosPerfil,
  inputRef,
  errors,
  className,
  control,
  name,
  placeholder,
  onChange,
}) => {
  const mensagem = 'Nenhum contrato encontrado';

  const { request: requestContratos, data: lista } = useFetch([]);

  React.useEffect(() => {
    if (dadosPerfil?.perfil == 'Supervisor') {
      requestContratos(
        PESQUISAR_CONTRATOS_SUPERVISOR(
          dadosPerfil.idCorreios,
          dadosPerfil.idCorreiosPF,
        ),
      );
    } else {
      requestContratos(PESQUISAR_CONTRATOS_PJ(idCorreios, 'PJ'));
    }
  }, []);
  return (
    <Datalist
      options={[
        ...lista.map((item) => ({
          value: item.nuContrato,
          label: item.nuContrato,
        })),
      ]}
      name={name}
      className={className}
      label="Contratos"
      placeholder={placeholder}
      inputRef={inputRef}
      errors={errors}
      control={control}
      onChange={onChange}
      mensagem={mensagem}
    />
  );
};

export default SelectContratos;
